import moment from 'moment'
import config from '@/modules/booking/config'
import BookingListColumnModel from 'booking/models/booking-list-column-model'
import { sanitizeListColumns } from '@/redux/util/sanitizeListColumns'

import request from '@/modules/base/util/request'

const { urls } = config

// actions
export const ACTION_PREFIX = 'bookingList'
const FINISHED_FETCHING_LIST_SETTING = `${ACTION_PREFIX}/finishedBookingListSetting`
const ERROR_FETCHING_LIST_SETTING = `${ACTION_PREFIX}/errorBookingListSetting`

const SHOW_LOADER = `${ACTION_PREFIX}/showLoader`
const HIDE_LOADER = `${ACTION_PREFIX}/hideLoader`
const REFRESH = `${ACTION_PREFIX}/refresh`
const STOP_REFRESHING = `${ACTION_PREFIX}/stopRefreshing`
const SET_PAGINATION = `${ACTION_PREFIX}/setPagination`
const SET_FILTER = `${ACTION_PREFIX}/setFilter`
const RESET_FILTER = `${ACTION_PREFIX}/resetFilter`
const SET_LIST_ITEMS = `${ACTION_PREFIX}/setItems`
const SET_SEARCH_TERM = `${ACTION_PREFIX}/setSearchTerm`

const initialState = {
  bookings: [],
  setting: {
    columns: [],
  },
  contextMenu: null,
  isLoading: false,
  searchTerm: '',
  filter: {
    type: 'all',
    timePeriod: {
      name: 'all',
      dateFrom: moment().subtract(14, 'days').toISOString(),
      dateTo: moment().toISOString(),
    },
  },
  pagination: {
    offset: 0, // current starting point in list
    count: 0, // count of filtered turnovers
    totalCount: 0, // count of all turnovers
    limit: 20, // max turnovers on page
  },
  shouldRefresh: false,
}

export default function reducer(state = initialState, action) {
  // test
  switch (action.type) {
    case SHOW_LOADER:
      return { ...state, isLoading: true }

    case HIDE_LOADER:
      return { ...state, isLoading: false }

    case REFRESH:
      return { ...state, shouldRefresh: true }

    case STOP_REFRESHING:
      return { ...state, shouldRefresh: false }

    case SET_PAGINATION:
      const { pagination } = action
      const updatedPagination = Object.assign({}, state.pagination, pagination)
      return { ...state, pagination: updatedPagination }

    case SET_FILTER:
      const { filter } = action
      const updatedFilter = Object.assign({}, state.filter, filter)
      return { ...state, filter: updatedFilter, pagination: initialState.pagination }

    case RESET_FILTER:
      return { ...state, filter: initialState.filter, pagination: initialState.pagination }

    case SET_SEARCH_TERM:
      const { searchTerm } = action
      return { ...state, searchTerm, pagination: initialState.pagination }

    case SET_LIST_ITEMS:
      const { data } = action
      return Object.assign({}, state, {
        booking: data,
      })
    case FINISHED_FETCHING_LIST_SETTING: {
      const { setting } = action
      return {
        ...state,
        setting,
      }
    }
    default:
      return state
  }
}

// action creators
export const showLoader = () => ({ type: SHOW_LOADER })
export const hideLoader = () => ({ type: HIDE_LOADER })
export const refreshList = () => ({ type: REFRESH })
export const stopRefreshingList = () => ({ type: STOP_REFRESHING })
export const setPagination = (pagination) => ({ type: SET_PAGINATION, pagination })
export const setActiveFilter = (filter) => ({ type: SET_FILTER, filter })
export const resetFilter = () => ({ type: RESET_FILTER })
export const setSearchTerm = (searchTerm) => ({ type: SET_SEARCH_TERM, searchTerm })
export const setListItems = (items) => ({ type: SET_LIST_ITEMS, items })

export const destructListResponse = (response) => {
  return new Promise((resolve) => {
    const { body } = response
    const { data } = body
    resolve(data)
  })
}

export const reduceToResource = async(response) => {
  const { body } = response
  const { data } = body
  return data
}

const finishedFetchingListSetting = (setting) => ({ type: FINISHED_FETCHING_LIST_SETTING, setting })
const errorFetchingListSetting = (error) => ({ type: ERROR_FETCHING_LIST_SETTING, error })
export const fetchListSettings = () => {
  return (dispatch) => {
    request(urls.listSetting, { auth: true, isConcurrent: true })
      .then((response) => {
        const {
          body: {
            data: { columns },
            meta: {
              defaultSort,
              sortBy,
            },
          },
        } = response

        const sanitizedColumns = sanitizeListColumns(columns, defaultSort, sortBy)
        const bookingColumns = sanitizedColumns.map((column) => {
          column.displayed = true

          return new BookingListColumnModel(column)
        })

        dispatch(finishedFetchingListSetting({ columns: bookingColumns }))
      })
      .catch((error) => {
        dispatch(errorFetchingListSetting(error))
      })
  }
}
